import React from 'react'

import { Portlet, Row, Col, Button, Form } from '_zari/core'

import { ZariContext } from '_zari/context'
import { AdminContext } from 'contexts/AdminContext'

import * as InventariosService from 'services/inventario.service'

import { downloadFileAsBlob } from '../_util'

import { MesContabilidadSelect } from 'sharedComponents/select'

const Formato3_7 = () => {
  const __zariContext = React.useContext(ZariContext)
  const __adminContext = React.useContext(AdminContext)

  const [mes, setMes] = React.useState(__adminContext.mesTrabajo)
  const [flagValorizado, setFlagValorizado] = React.useState(false)
  const [flagConsolidado, setFlagConsolidado] = React.useState(false)
  const [flagOtrasPresentaciones, setFlagOtrasPresentaciones] = React.useState(false)
  const [flagIncluirStockCero, setFlagIncluirStockCero] = React.useState(false)
  const [resultados, setResultados] = React.useState(null)
  const [buscando, setBuscando] = React.useState(false)

  const getParams = () => ({ mes, flagValorizado, flagConsolidado, flagOtrasPresentaciones, flagIncluirStockCero })

  const clickDescargarReporte = React.useCallback(() => {
    __zariContext.loader.open('Descargando reporte - Formato 3.7...')
    InventariosService.descargarReporteFormato3_7(getParams())
      .then(({ data }) => {
        downloadFileAsBlob(data, 'Reporte Formato 3_7.xlsx')
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [mes, flagValorizado, flagConsolidado, flagOtrasPresentaciones, flagIncluirStockCero, __zariContext])

  const clickBuscar = React.useCallback(() => {
    setBuscando(true)
    InventariosService.consultaFormato3p7(getParams())
      .then(({ data }) => setResultados(data))
      .catch(({ data }) => __zariContext.snack('error', data?.error || 'Error al consultar'))
      .finally(() => setBuscando(false))
  }, [mes, flagValorizado, flagConsolidado, flagOtrasPresentaciones, flagIncluirStockCero, __zariContext])

  return (
    <Portlet>
      <Portlet.Header title='Reporte Formato 3.7' />
      <Portlet.Body>
        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='Mes' md={4} alignRightAt='md' />
              <Col md={8}>
                <MesContabilidadSelect id='select-mes' name='select-mes' value={mes} onChange={e => setMes(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={6} />
        </Row>
        <Row>
          <Col md={4}>
            <Form.Checkbox id='checkbox-valorizado' name='checkbox-valorizado' label='Valorizado' checked={flagValorizado} onChange={() => setFlagValorizado(prev => !prev)} />
          </Col>
          <Col md={4}>
            <Form.Checkbox id='checkbox-consolidado' name='checkbox-consolidado' label='Consolidado' checked={flagConsolidado} onChange={() => setFlagConsolidado(prev => !prev)} />
          </Col>
          <Col md={4}>
            <Form.Checkbox id='checkbox-otrasPresentaciones' name='checkbox-otrasPresentaciones' label='Otras Presentaciones' checked={flagOtrasPresentaciones} onChange={() => setFlagOtrasPresentaciones(prev => !prev)} />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <Form.Checkbox id='checkbox-IncluirStockCero' name='checkbox-IncluirStockCero' label='Incluir stock cero' checked={flagIncluirStockCero} onChange={() => setFlagIncluirStockCero(prev => !prev)} />
          </Col>
        </Row>
        <Row>
          <Col md={12} className='text-right'>
            <Button variant='outline-primary' onClick={clickBuscar} disabled={buscando} className='mr-2'>
              {buscando ? 'Buscando...' : 'Buscar'}
            </Button>
            <Button onClick={clickDescargarReporte}>Descargar Reporte</Button>
          </Col>
        </Row>

        {resultados && (
          <Row className='mt-3'>
            <Col md={12}>
              <div style={{ maxHeight: 500, overflowY: 'auto' }}>
                <table className='table table-sm table-striped table-bordered'>
                  <thead>
                    <tr>
                      <th>CODIGO</th>
                      <th>T. EXISTENCIA</th>
                      <th>DESCRIPCION</th>
                      <th>U.M.</th>
                      <th className='text-right'>CANTIDAD</th>
                      {flagValorizado && <th className='text-right'>VALOR UNIT.</th>}
                      {flagValorizado && <th className='text-right'>COSTO TOTAL</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {resultados.map((r, i) => (
                      <tr key={i}>
                        <td>{r.codigo}</td>
                        <td>{r.tipoExistencia}</td>
                        <td>{r.nombre}</td>
                        <td>{r.unidadMedida}</td>
                        <td className='text-right'>{r.cantidad}</td>
                        {flagValorizado && <td className='text-right'>{r.valorUnitario}</td>}
                        {flagValorizado && <td className='text-right'>{r.costoTotal}</td>}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <small className='text-muted'>{resultados.length} registros encontrados</small>
            </Col>
          </Row>
        )}
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(Formato3_7)
